<template>
  <div>
    <SidebarSearch @submit="submitForm" @clear="clearForm">
      <SearchCollapse :expanded="true" title="Geral">
        <NxInput
        name="nome"
        type="text"
        label="Nome do Cargo:"
        placeholder="Digite o nome do cargo"
        @update:value="handleInputUpdate('nome', $event)"
      ></NxInput>
      </SearchCollapse>
    </SidebarSearch>
  </div>
</template>

<script>
import SidebarSearch from '@/containers/layout/sidebars/SidebarSearch.vue'
import SearchCollapse from '@/containers/layout/sidebars/components/SearchCollapse.vue'

export default {
  name: 'SidebarOrganizacaoCargos',
  components: { SidebarSearch, SearchCollapse },
  data () {
    return {
      // Form data devem seguir as nomenclaturas esperadas pelo backend
      form: {
        nome: null
      }
    }
  },
  methods: {
    submitForm () {
      this.$nextTick(() => {
        this.$emit('search', this.form)
      })
    },
    clearForm () {
      this.$root.$emit('clearForm')
      this.$nextTick(() => {
        this.submitForm()
      })
    },
    clearField (field) {
      this.form[field] = null
    },
    handleInputUpdate (fieldName, inputedValue, clean = true) {
      if (inputedValue) {
        this.form[fieldName] = clean ? inputedValue.replace(/[^a-zA-Z0-9 ]/g, '') : inputedValue
      } else {
        this.clearField(fieldName)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/position/components/search/SidebarOrganizacaoCargos.vue